import React from 'react';
import { Link } from "react-router-dom";
import { CATEGORIES } from './categorie.constant';

const Categorie = () => {
  return (
    <div className="categories-container">
      {CATEGORIES.map((categorie) => (
        <div key={categorie.id} className="categorie-item">
          <Link to={`/annonces?categorieId=${categorie.id}`}>
            <img
              src={`./img/${categorie.image}`}
              alt={categorie.label}
              className="categorie-image"
            />
          </Link>
        </div>
      ))}
    </div>
  );
};

export default Categorie;
